import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  root: {
    "& ul": {
      margin: 0,
      padding: 0,
      position: "relative",
      "&:before": {
        background: "#CCCCCC",
        height: "107%",
        width: 1,
        content: '""',
        position: "absolute",
        left: -1,
        zIndex: 1,
      },
      "&.singlechoice, &.multiplechoice": {
        "& li:nth-child(1), li:nth-child(11)": {
          "& .MuiLinearProgress-bar": {
            background: "#A66FAE",
          },
        },
        "& li:nth-child(2), li:nth-child(12)": {
          "& .MuiLinearProgress-bar": {
            background: "#E48D4C !important",
          },
        },
        "& li:nth-child(3), li:nth-child(13)": {
          "& .MuiLinearProgress-bar": {
            background: "#0082BE !important",
          },
        },
        "& li:nth-child(4), li:nth-child(14)": {
          "& .MuiLinearProgress-bar": {
            background: "#7BBB95 !important",
          },
        },
        "& li:nth-child(5), li:nth-child(15)": {
          "& .MuiLinearProgress-bar": {
            background: "#EEC90F !important",
          },
        },
        "& li:nth-child(6), li:nth-child(16)": {
          "& .MuiLinearProgress-bar": {
            background: "#DF7796 !important",
          },
        },
        "& li:nth-child(7), li:nth-child(17)": {
          "& .MuiLinearProgress-bar": {
            background: "#44BCCE !important",
          },
        },
        "& li:nth-child(8), li:nth-child(18)": {
          "& .MuiLinearProgress-bar": {
            background: "#8F9BD8 !important",
          },
        },
        "& li:nth-child(9), li:nth-child(19)": {
          "& .MuiLinearProgress-bar": {
            background: "#685BAA !important",
          },
        },
        "& li:nth-child(10), li:nth-child(20)": {
          "& .MuiLinearProgress-bar": {
            background: "#9CD65B !important",
          },
        },
      },
      "&.emojiranking": {
        "&:before": {
          height: "106%",
        },
        "& $yAxisLabel": {
          paddingLeft: 45,
        },
        "& .chart-list": {
          margin: "20px 0",
        },
      },
    },
    "& .graph-note": {
      width: 320,
      textAlign: "center",
      marginTop: 10,
      marginBottom: 10,
    },
    "& .large-label": {
      "& .qus-label": {
        width: 150,
        left: -167,
      },
    },
  },
  chartList: {
    display: "flex",
    alignItems: "flex-start",
    margin: "22px 0",
  },
  yAxisLabel: {
    width: 90,
    fontSize: 12,
    color: "#525252",
    marginRight: 12,
    marginLeft: 6,
    position: "absolute",
    left: -108,
    lineHeight: "16px",
  },
  progressBar: {
    width: 180,
    background: "#F1F4F6",
    borderRadius: "0 20px 20px 0",
    height: 10,
    "& .MuiLinearProgress-bar": {
      background: "#FAC129",
      borderRadius: "0 20px 20px 0",
    },
  },
  count: {
    width: 70,
    height: 20,
    marginLeft: 12,
    "& .count": {
      minWidth: 11,
    },
  },
  starranking: {
    background: "red",
  },
  graphIcon: {
    marginLeft: 5,
    "& svg": {
      width: 18,
      height: 18,
    },
  },
  tick: {
    color: "#36A07D",
  },
  cross: {
    color: "#EF6363",
  },
  emojiImage: {
    display: "block",
  },
  xAxis: {
    borderTop: "#CCCCCC solid 1px",
    width: 180,
    marginLeft: -1,
    marginTop: -9,
    "& span": {
      fontSize: 12,
      color: "#888888",
      position: "relative",
      paddingTop: 5,
      "&:after": {
        content: "''",
        height: 6,
        width: 1,
        background: "#CCCCCC",
        position: "absolute",
        top: 0,
      },
      "&:nth-child(1)": {
        marginLeft: -4,
        "&:after": {
          left: 4,
        },
      },
      "&:nth-child(2)": {
        marginLeft: 4,
        "&:after": {
          left: 4,
        },
      },
      "&:nth-child(3)": {
        marginRight: -4,
        "&:after": {
          right: 4,
        },
      },
    },
  },
  labelXs: {
    "& .qus-label": {
      width: 90,
      left: -108,
    },
  },
  labelSm: {
    "& .qus-label": {
      width: 125,
      left: -144,
    },
  },
  labelMd: {
    "& .qus-label": {
      width: 165,
      left: -182,
    },
  },
  labelLg: {
    "& .qus-label": {
      width: 165,
      left: -182,
    },
  },
  countWrapper: {
    minWidth: 50,
    maxWidth: 80,
  },
}));
